import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useApp, useTranslate } from "./common.jsx";

// One tooltip surface also works inside native dialogs (the browser top layer).
export function Tooltips() {
  const { lang } = useApp();
  const t = useTranslate();
  const [tip, setTip] = useState(null);
  useEffect(() => {
    let current, timer, described;
    const hide = () => {
      clearTimeout(timer);
      if (current) {
        if (described) current.setAttribute("aria-describedby", described);
        else current.removeAttribute("aria-describedby");
      }
      current = null;
      setTip(null);
    };
    const show = (event) => {
      if (event.pointerType === "touch") return;
      const el = event.target.closest?.("button, a, [role=button]");
      if (!el || !(el.querySelector("svg") || el.hasAttribute("aria-label") || el.hasAttribute("title") || el.dataset.tooltip || el.classList.contains("languagebutton"))) return;
      if (current === el) return;
      hide();
      let label = el.getAttribute("title") || el.dataset.tooltip || el.getAttribute("aria-label") || el.textContent.trim();
      if (el.classList.contains("languagebutton")) label = lang === "ka" ? "Switch to English" : "ქართულზე გადართვა";
      if (!label) return;
      // Suppress the browser's duplicate tooltip; retain the label on the control.
      if (el.hasAttribute("title")) { el.dataset.tooltip = label; el.removeAttribute("title"); }
      current = el;
      described = el.getAttribute("aria-describedby");
      timer = setTimeout(() => {
        if (!el.isConnected) return hide();
        const r = el.getBoundingClientRect();
        const width = Math.min(264, innerWidth - 24);
        const below = r.top < 100;
        const rail = !!el.closest(".filter-rail");
        el.setAttribute("aria-describedby", [described, "fontlab-tooltip"].filter(Boolean).join(" "));
        setTip({ label: t(label), width, rail, left: rail ? r.right + 14 : Math.max(width / 2 + 12, Math.min(innerWidth - width / 2 - 12, r.left + r.width / 2)), top: rail ? Math.max(50, Math.min(innerHeight - 50, r.top + r.height / 2)) : below ? r.bottom + 12 : r.top - 12, below, host: el.closest("dialog") || document.body, escape: /close/i.test(label) });
      }, event.type === "focusin" ? 80 : 260);
    };
    const leave = (event) => { if (current && !current.contains(event.relatedTarget)) hide(); };
    const key = (event) => { if (event.key === "Escape") hide(); };
    document.addEventListener("pointerover", show);
    document.addEventListener("focusin", show);
    document.addEventListener("pointerout", leave);
    document.addEventListener("focusout", leave);
    document.addEventListener("pointerdown", hide);
    document.addEventListener("keydown", key);
    document.addEventListener("scroll", hide, true);
    window.addEventListener("resize", hide);
    return () => {
      hide();
      document.removeEventListener("pointerover", show);
      document.removeEventListener("focusin", show);
      document.removeEventListener("pointerout", leave);
      document.removeEventListener("focusout", leave);
      document.removeEventListener("pointerdown", hide);
      document.removeEventListener("keydown", key);
      document.removeEventListener("scroll", hide, true);
      window.removeEventListener("resize", hide);
    };
  }, [lang]);
  return tip && createPortal(
    <div id="fontlab-tooltip" role="tooltip" className={"fontlab-tooltip " + (tip.rail ? "beside" : tip.below ? "below" : "above")} style={{ left: tip.left, top: tip.top, maxWidth: tip.width }}>
      <span className="tooltip-spark" aria-hidden="true">✦</span>
      <span>{tip.label}</span>
      {tip.escape && <kbd>Esc</kbd>}
    </div>, tip.host);
}

